import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';
import language from "@lang/language";

const PriceB = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={styles.PriceB}>
		  <div>
			  <span>{priceData.price} </span>
			  <span className={styles.currency}>{language.evro}</span>

			  {priceData.basePrice !== priceData.price &&
				<span className={styles.oldPrice}>{priceData.basePrice} {language.evro}</span>
			  }
		  </div>
	  </div>
	);
}

PriceB.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceB;
